import { api } from 'shared/api'
import { AiAgentPlaygroundSchemas } from 'shared/api/requests/aiAgentPlayground/schemas'

export const AiAgentPlaygroundApi = {
  initThread: api.account.createPost({
    url: '/aiAgentPlayground/initThread',
    schemas: AiAgentPlaygroundSchemas.initThread,
    scope: 'ai',
    section: 'ai_agent_playground',
  }),
  startThread: api.account.createPost({
    url: '/aiAgentPlayground/startThread',
    schemas: AiAgentPlaygroundSchemas.startThread,
    scope: 'ai',
    section: 'ai_agent_playground',
  }),
  sendEvent: api.account.createPost({
    url: '/aiAgentPlayground/threadEvent',
    schemas: AiAgentPlaygroundSchemas.sendEvent,
    scope: 'ai',
    section: 'ai_agent_playground',
  }),
}
